import CardsList from "@/components/cardsList";
import { OEM_SOLUTIONS_CONSTANTS } from "./constants";

const ServicesComponent = () => {
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      desc={OEM_SOLUTIONS_CONSTANTS.desc}
      title={OEM_SOLUTIONS_CONSTANTS.title}
      list={OEM_SOLUTIONS_CONSTANTS.list}
      spacing={{ base: 8, md: 16 }}
    />
  );
};

export default ServicesComponent;
